










































































































































































































































































































































import Element from 'element-ui'
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { UnitArchaeologyData, emptyData, getInfo, postData, putData } from '@/api/heritageUnit/unitArchaeology'
import { getLookupByType, DDLItem } from '@/api/common/select'
import { enFirstType, enLookupType } from '@/configs/enums'
import { schemeFormat } from '@/configs/fileTypes'
import { validateIntKey, validateFloat, showVaildMsg } from '@/configs/validate'
import { getDDLItem, tryToInt } from '@/configs/functions'
import { OfficialDocData } from '@/api/officialDoc/doc'
import { UploadOptData } from '@/api/common/upload'
import { AttachInfo } from '@/api/common/attach'
import hspGallery from '@/components/upload/gallery.vue'
import singleFile from '@/components/upload/singleFile.vue'
import DocSelector from '@/components/officialDoc/select.vue'
import FormDialog from '@/components/dialog/formDialog.vue'

const getFormRules = (form: { [key: string]: string }) => {
  return {
    InvestigationArea: [{ validator: validateFloat, message: '请输入数字', trigger: 'blur' }],
    InvestigationFundAmount: [{ validator: validateFloat, message: '请输入数字', trigger: 'blur' }],
    InvestigationCategory: [{ required: true, validator: validateIntKey('请选择调查性质'), trigger: 'change' }]
  }
}
@Component({
  components: { FormDialog, DocSelector, hspGallery, singleFile }
})
export default class UnitArchaeologyForm extends Vue {
  public name = 'UnitArchaeologyForm'
  // 关闭窗口，在 dialog 的 :before-close属性中触发，然后调用父级中的方法
  @Prop({ default: null })
  public closeDialog!: () => void
  public showDialog: boolean = false

  public expandNames: string[] = ['base']//, 'investigation', 'exploration', 'dig']
  public loading: boolean = false
  public schemeExt: string = schemeFormat
  public categoryList: DDLItem[] = []
  public form: UnitArchaeologyData = Object.assign({}, emptyData)
  public rules = getFormRules(this.form)
  public $refs!: {
    formData: Element.Form
    sfText: singleFile
    sfDrawing: singleFile
    gyAssessment: hspGallery
    gyPicture: hspGallery
  }
  get investigationYearMonth(): string {
    const f = this.form
    var data = ''
    if (f.InvestigationYear > 0 && f.InvestigationMonth > 0) {
      data = f.InvestigationYear.toString() + '-' + f.InvestigationMonth.toString()
    }
    return data
  }
  set investigationYearMonth(data: string) {
    const f = this.form
    if (data != '') {
      let sp = data.split('-')
      f.InvestigationYear = tryToInt(sp[0])
      f.InvestigationMonth = tryToInt(sp[1])
    }
    else {
      f.InvestigationYear = f.InvestigationMonth = 0
    }
  }
  get explorationYearMonth(): string {
    const f = this.form
    var data = ''
    if (f.ExplorationYear > 0 && f.ExplorationMonth > 0) {
      data = f.ExplorationYear.toString() + '-' + f.ExplorationMonth.toString()
    }
    return data
  }
  set explorationYearMonth(data: string) {
    const f = this.form
    if (data != '') {
      let sp = data.split('-')
      f.ExplorationYear = tryToInt(sp[0])
      f.ExplorationMonth = tryToInt(sp[1])
    }
    else {
      f.ExplorationYear = f.ExplorationMonth = 0
    }
  }
  get digYearMonth(): string {
    const f = this.form
    var data = ''
    if (f.DigYear > 0 && f.DigMonth > 0) {
      data = f.DigYear.toString() + '-' + f.DigMonth.toString()
    }
    return data
  }
  set digYearMonth(data: string) {
    const f = this.form
    if (data != '') {
      let sp = data.split('-')
      f.DigYear = tryToInt(sp[0])
      f.DigMonth = tryToInt(sp[1])
    }
    else {
      f.DigYear = f.DigMonth = 0
    }
  }
  public hasIstRecord: boolean = false
  public hasIstSpecimen: boolean = false
  public hasExpRecord: boolean = false
  public hasExpSmallPiece: boolean = false
  public hasDigRecord: boolean = false
  public hasDigSmallPiece: boolean = false
  public onFileChange(data: { opts: UploadOptData, file: AttachInfo }) {
    const opt = data.opts
    const hasFile = data.file.Id > 0
    const f = this.form
    switch (opt.refType) {
      case f.AttachTypeIstRecord:
        this.hasIstRecord = hasFile
        break
      case f.AttachTypeIstSpecimen:
        this.hasIstSpecimen = hasFile
        break
      case f.AttachTypeExpRecord:
        this.hasExpRecord = hasFile
        break
      case f.AttachTypeExpSmallPiece:
        this.hasExpSmallPiece = hasFile
        break
      case f.AttachTypeDigRecord:
        this.hasDigRecord = hasFile
        break
      case f.AttachTypeDigSmallPiece:
        this.hasDigSmallPiece = hasFile
        break
      default:
        break
    }
  }
  public hasIstDrawing: boolean = false
  public hasIstPicture: boolean = false
  public hasExpDrawing: boolean = false
  public hasExpPicture: boolean = false
  public hasDigDrawing: boolean = false
  public hasDigPicture: boolean = false
  public onGalleryChange(data: { opts: UploadOptData, files: AttachInfo[] }) {
    const list = data.files
    const hasFiles = list && list.length > 0
    const opt = data.opts
    const f = this.form
    switch (opt.refType) {
      case f.AttachTypeExpRecord:
        this.hasIstDrawing = hasFiles
        break
      case f.AttachTypeExpSmallPiece:
        this.hasIstPicture = hasFiles
        break
      case f.AttachTypeExpDrawing:
        this.hasExpDrawing = hasFiles
        break
      case f.AttachTypeExpPicture:
        this.hasExpPicture = hasFiles
        break
      case f.AttachTypeDigDrawing:
        this.hasDigDrawing = hasFiles
        break
      case f.AttachTypeDigPicture:
        this.hasDigPicture = hasFiles
        break
      default:
        break
    }
  }
  public getDoc(info: { data: OfficialDocData, refTo: string }) {
    const docId = info.data.Id
    if (info.refTo === 'investigation') {
      this.form.InvestigationDocId = docId
    }
    if (info.refTo === 'exploration') {
      this.form.ExplorationDocId = docId
    }
    if (info.refTo === 'dig') {
      this.form.DigDocId = docId
    }
  }
  public created() {
  }
  public fetchSource() {
    const firstType = enFirstType.Select
    if (this.categoryList.length === 0) {
      getLookupByType(enLookupType.InvestigationCategory, firstType).then((response: { data: any }) => {
        const data = response.data
        if (data) {
          this.categoryList = data
        }
      })
    }
  }
  public mounted() {
    window.eventBus.$on("openUnitArchaeologyForm", (info: { unitId: number, dataId: number }) => {
      this.expandNames = ['base']
      this.fetchSource()
      this.fetchData(info)
    })
  }
  public beforeDestroy() {
    window.eventBus.$off("openUnitArchaeologyForm")
  }
  public open() {
    this.showDialog = true
  }
  public close() {
    this.showDialog = false
    this.$refs.formData.resetFields()
    if (this.closeDialog) {
      this.closeDialog()
    }
  }
  public fetchData(info: { unitId: number, dataId: number }) {
    this.open()
    this.form = Object.assign({}, emptyData)
    this.loading = true
    getInfo(info.dataId).then((response: { data: any }) => {
      this.form = response.data
      this.expandNames = ['base']//, 'investigation', 'exploration', 'dig']
      if (this.form.IsInvestigation) {
        this.expandNames.push('investigation')
      }
      if (this.form.IsExploration) {
        this.expandNames.push('exploration')
      }
      if (this.form.IsDig) {
        this.expandNames.push('dig')
      }
      if (info.dataId === 0) {
        this.form.UnitId = info.unitId
      }
      this.loading = false
    }).catch((error: any) => {
      console.log(error)
    })
  }
  public sendData(data: UnitArchaeologyData) {
    window.eventBus.$emit("submitUnitArchaeologyForm", {
      data: data
    })
  }
  public onSubmit() {
    this.$refs.formData.validate((valid: boolean, obj: any) => {
      if (valid) {
        const f = Object.assign({}, this.form)
        const promist = f.Id > 0 ? putData(f.Id, f) : postData(f)
        promist.then((response: { data: any }) => {
          const data = response.data
          const msg = this.form.Id > 0 ? '保存' : '创建'
          if (data && !data.IsError) {
            this.$message({
              message: `${msg}成功`,
              type: 'success'
            })
            this.sendData(f)
            this.close()
          } else {
            this.$message({
              dangerouslyUseHTMLString: true, message: `${data.Message}`,
              type: 'warning'
            })
            console.log(response)
          }
        }, (data: any) => {
          console.log(data)
        })
      }
      else {
        showVaildMsg(this.$message, obj)
      }
    })
  }
}
